import React, { useState, useEffect } from 'react';
import styles from './billing.module.scss';
import { Col, Row, Card, Table, Alert, Modal, Button, Form } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import CustomNavbar from '../customNavbar';
import { Chart } from "react-google-charts";
import { CustomButton } from '../../shared/customButton';
import { CustomStatusLabel } from '../../shared/customStatusLabel';
import { Formik } from 'formik';
import * as yup from 'yup';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { CustomTextField } from '../../shared/customTextField';
import { CustomModalIcon } from '../../shared/customModalIcon';

import { getBillingDetails, setBillingDetails, initializePayment, checkPaymentStatus } from '../../../services/util/billing';
import CSSLoader from '../../shared/cssLoader';
import { CustomAlertBox } from '../../shared/customAlertBox';
import { CustomPreIcon } from '../../shared/customPreIcon';
import { CustomIconButton } from '../../shared/customIconButton';
import { toast } from 'react-toastify';
import ReactTooltip from 'react-tooltip';
import jsPDF from 'jspdf';
let moment = require("moment");

const Billing = (props) => {
    let [isViewOpen, setViewOpen] = useState(false);
    let [viewValues, setViewValues] = useState({
        total_bill_amount: 0
    });
    let [isModalOpen, setModalOpen] = useState(false);
    let [isDetailsModalOpen, setDetailsModalOpen] = useState(false);
    let [billingDetails, setBillingDetailsState] = useState({
        carried_forward_amount: 0,
        monthly_usage_amount: 0,
        total_bill_amount: 0
    });
    let [isDataLoading, setDataLoading] = useState(false);
    let [isLoading, setLoading] = useState(false);
    let [currentCandidateAmount, setCurrentCandidateAmount] = useState();
    let [currentInterviewAmount, setCurrentInterviewAmount] = useState();
    let [previousCandidateAmount, setPreviousCandidateAmount] = useState();
    let [previousInterviewAmount, setPreviousInterviewAmount] = useState();
    let [tableValues, settableValues] = useState();
    let [tableFiltervalues, setFilteredValues] = useState();
    let [isPaymentLoading, setPaymentLoading] = useState(false);
    let [companyPaymentState, setCompanyPaymentState] = useState();
    let [isURLLoading, setURLLoading] = useState(false);
    let [bilingContactDetailsStatus, setBilingContactDetailsStatus] = useState(false);
    

    const breadcrumb = [
        {
            pathaddress: '',
            pathname: 'Billing',
            isActive: true,
            key: 1 + 'Billing'
        }
    ];

    const stepPieOptions = {
        slices: [
            {
                color: "#2DA6C0"
            },
            {
                color: "#12B76A"
            },
        ],
        legend: "none",
        tooltip: {
            showColorCode: true
        },
        chartArea: {
            width: "85%",
            height: "85%"
        },
        pieHole: 0.5,
    };

    const stepPieDataNoneOptions = {
        slices: [
            {
                color: "#F2F2F2"
            },
        ],
        legend: "none",
        'tooltip': {
            trigger: 'none'
        },
        chartArea: {
            width: "85%",
            height: "85%"
        },
        pieHole: 0.5,
    };

    //yup validations
    const schema = yup.object({
        mnumber: yup.string().trim().min(8, 'Should be more than 4 digits').nullable(),
        address: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        city: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        country: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        province: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^'),
        postalCode: yup.number().typeError('Only numbers allowed').required('Required')
    });

    //on submit function
    const onSubmit = async (values) => {
        setLoading(true)
        let respond = await setBillingDetails(values.mnumber, values.address, values.city, values.country, values.province, (values.postalCode).toString());
        if (respond.success === true) {
            setLoading(false);
            setModalOpen(false);
            getAllBillingDetails();
        } else {
            setLoading(false);
        }
    }

    const viewPaymentDetals = (value) => {
        setViewOpen(true);
        setViewValues(value);
        getPreviousSeperateBill(value);
    }

    const hidePaymentDetals = () => {
        setViewOpen(false);
        setViewValues(null);
    }

    function searchValus(searchValue) {
        let searchVal = searchValue.toLowerCase();
        const filtered = tableValues.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
        setFilteredValues(filtered);
    }



    const getAllBillingDetails = async () => {
        setDataLoading(true)
        let respond = await getBillingDetails();
        if (respond.success === true) {
            setBillingDetailsState(respond.data);
            setBilingContactDetailsStatus(respond.data.billing_contact_details.is_billing_contact_details_set)
            settableValues(respond.data.generated_bills);
            setFilteredValues(respond.data.generated_bills);
            getSeperateBill(respond.data);
            setDataLoading(false);
        } else {
            setDataLoading(false);
        }
    }

    const tableBodyRow = (billingDetails && (billingDetails.bill_calculation)) && (billingDetails.bill_calculation.usage_bill).map((value, index) => (
        <tr key={index}>
            <td>{value.usage_type}</td>
            <td>{value.usage_type === "Candidate" ? value.current_candidate_count : value.usage_type === "Interview Minutes" ? value.current_chime_minutes_count : '0.00'}</td>
            <td>{value.usage_type === "Candidate" ? value.candidate_fee_calculation : value.usage_type === "Interview Minutes" ? value.fee_per_chime_minute_calculation : '0.00'}</td>
            <td className="text-right">USD ${value.usage_type === "Candidate" ? (value.total_for_candidate === 0 ? '0.00' : (value.total_for_candidate).toFixed(2)) : value.usage_type === "Interview Minutes" ? (value.total_for_chime === 0 ? '0.00' : (value.total_for_chime).toFixed(2)) : '0.00'}</td>
        </tr>
    ));
    const tableSecondBodyRow = (
        <>
            <tr>
                <td>Carried Forward</td>
                <td>-</td>
                <td>-</td>
                <td className="text-right">USD ${(billingDetails.carried_forward_amount).toFixed(2)}</td>
            </tr>
            <tr>
                <td>Total bill amount</td>
                <td>-</td>
                <td>-</td>
                <td className="text-right">USD ${(billingDetails.total_bill_amount).toFixed(2)}</td>
            </tr>
        </>

    );


    const modelTableBodyRow = (viewValues && (viewValues.bill_calculation)) && (viewValues.bill_calculation).map((value, index) => (
        <tr key={index}>
            <td>{value.usage_type}</td>
            <td>{value.usage_type === "Carried Forward" ? '-' : value.usage_count}</td>
            <td>{value.usage_type === "Carried Forward" ? '-' : value.usage_fee_per}</td>
            <td className="text-right">{value.total_per_services === 0 ? '0.00' : (value.total_per_services).toFixed(2)}</td>
        </tr>
    ));

    const getSeperateBill = (value) => {
        for (let index = 0; index < (value.bill_calculation.usage_bill).length; index++) {
            if ((value.bill_calculation.usage_bill)[index].usage_type === "Candidate") {
                setCurrentCandidateAmount((value.bill_calculation.usage_bill)[index].total_for_candidate)
            }
            if ((value.bill_calculation.usage_bill)[index].usage_type === "Interview Minutes") {
                setCurrentInterviewAmount((value.bill_calculation.usage_bill)[index].total_for_chime)
            }
        }
    }

    const getPreviousSeperateBill = (value) => {
        for (let index = 0; index < (value.bill_calculation).length; index++) {
            if ((value.bill_calculation)[index].usage_type === "Candidate") {
                setPreviousCandidateAmount((value.bill_calculation)[index].total_per_services)
            }
            if ((value.bill_calculation)[index].usage_type === "Interview Minutes") {
                setPreviousInterviewAmount((value.bill_calculation)[index].total_per_services)
            }
        }
    }

    //pay here implementation start

    window.payhere.onCompleted = async function onCompleted() {
        if (JSON.parse(localStorage.getItem('paymentStatus')) === true) {
            let respond = await checkPaymentStatus();
            if (respond.success === true) {
                if (respond.data.is_payment_overdue === false) {
                    setPaymentLoading(false);
                    toast.success(<div><i className="fas fa-check fa-lg"></i>&nbsp;&nbsp;Payment success. Please re-login to system</div>, {
                        position: "top-right",
                        autoClose: 2500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    props.mainHistory.push('/signin');
                } else {
                    setPaymentLoading(false);
                    getAllBillingDetails();
                }
            } else {
                setPaymentLoading(false);
                getAllBillingDetails();
            }
        } else {
            setPaymentLoading(false);
            getAllBillingDetails();
        }

    };

    window.payhere.onDismissed = function onDismissed() {
        toast.error(<div><i className="fas fa-exclamation-triangle fa-lg"></i>&nbsp;&nbsp;{"Payment dismissed"}</div>, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        setPaymentLoading(false);
    };

    window.payhere.onError = function onError(error) {
        toast.error(<div><i className="fas fa-exclamation-triangle fa-lg"></i>&nbsp;&nbsp;{"Payment Error"}</div>, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        setPaymentLoading(false);
    };

    const paynow = async (values) => {
        setPaymentLoading(true);
        let paymentDetails = await initializePayment(values);
        if (paymentDetails.success) {

            let payment = {
                sandbox: paymentDetails.data.sandbox,
                merchant_id: paymentDetails.data.merchant_id,
                return_url: process.env.REACT_APP_FRONTEND_BASE_URL + process.env.REACT_APP_RETURN_URL,
                cancel_url: process.env.REACT_APP_FRONTEND_BASE_URL + process.env.REACT_APP_CANCEL_URL,
                notify_url: process.env.REACT_APP_REST_API_BASE_URL + process.env.REACT_APP_NOTIFY_URL,
                order_id: paymentDetails.data.order_id,
                items: paymentDetails.data.order_title,
                amount: paymentDetails.data.amount,
                currency: paymentDetails.data.currency,
                first_name: paymentDetails.data.billing_contact_details.billing_first_name,
                last_name: paymentDetails.data.billing_contact_details.billing_last_name,
                email: paymentDetails.data.email,
                phone: paymentDetails.data.billing_contact_details.phone_no,
                address: paymentDetails.data.billing_contact_details.street_address,
                city: paymentDetails.data.billing_contact_details.city,
                country: paymentDetails.data.billing_contact_details.country,
                custom_1: paymentDetails.data.custom_1,
                hash: paymentDetails.data.hash
            };

            window.payhere.startPayment(payment);

        } else {
            setPaymentLoading(false);
        }
    }

    //pay here implementation end


    // Function to generate and download the PDF
    const downloadAsPDF = (values) => {
        if(!bilingContactDetailsStatus){
            toast.error(<div><i className="fas fa-exclamation-triangle fa-lg"></i>&nbsp;&nbsp;{"Please provide billing contact details before download"}</div>, {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        else{
            const doc = new jsPDF();

        // Generate the invoice ID
        const generateInvoiceId = () => {
            const randomNumber = Math.floor(Math.random() * 100000000);
            return `INV-${randomNumber}`;
        };
        const invoiceId = generateInvoiceId();

        // Add the invoice ID
        doc.setFontSize(11);
        doc.setTextColor(0);
        doc.setFont('helvetica', 'normal');
        doc.text(`Invoice ID: ${invoiceId}`, 140, 30);

        const invoice = ('Invoice')
        doc.setFontSize(16);
        doc.setTextColor(0);
        doc.text(invoice, 140, 20,);


        const companyName = ('HIRETRACE')
        doc.setFontSize(20);
        doc.setTextColor(85, 158, 223);
        doc.text(companyName, 20, 20,);


        // Add divider line
        const lineY1 = 35; // Y-coordinate of the line
        const lineLength1 = doc.internal.pageSize.width - 32; // Adjust line length

        doc.setLineWidth(0.5);
        doc.setDrawColor('#CCCCCC');
        doc.line(20, lineY1, 20 + lineLength1, lineY1);

        // Add today's date 
        const today = new Date().toISOString().split('T')[0];
        doc.setFontSize(11);
        doc.setTextColor(0);
        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.width;
        doc.text(`Date: ${today}`, 20, 30);

        const invoiceTo = 'Invoice To';
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        doc.setFont('helvetica', 'bold');
        doc.text(invoiceTo, 20, 45);

        // Get contact details as an array
        const contactDetailsValue = [
            (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? <span className={styles.notAvailableTag}>Not available</span> : (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.street_address,
            (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? <span className={styles.notAvailableTag}>Not available</span> : (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.city,
            (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? <span className={styles.notAvailableTag}>Not available</span> : (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.country,
            (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? <span className={styles.notAvailableTag}>Not available</span> : (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.province,
            (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? <span className={styles.notAvailableTag}>Not available</span> : (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.postal_code,
            (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? <span className={styles.notAvailableTag}>Not available</span> : (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.phone_no

        ];
        doc.setFontSize(11);
        doc.setTextColor(128, 128, 128);
        doc.setFont('helvetica', 'normal');
        let contactDetailsY = 50;
        contactDetailsValue.forEach(value => {
            doc.text(String(value), 20, contactDetailsY);
            contactDetailsY += 5; // Increase the Y position for the next value
        });

        // Add divider line
        const lineY2 = contactDetailsY; // Y-coordinate of the line
        const lineLength2 = doc.internal.pageSize.width - 32; // Adjust line length

        doc.setLineWidth(0.5);
        doc.setDrawColor('#CCCCCC');
        doc.line(20, lineY2, 20 + lineLength2, lineY2);

        const usagePeriod = 'Usage Period:';
        doc.setFontSize(11);
        doc.setTextColor(0);
        doc.setFont('helvetica', 'bold');
        doc.text(usagePeriod, 20, 90);

        // Add usage period value
        const usagePeriodValue = (billingDetails.is_free_trail) ? 'Free Trial' : (values && values.billing_period) && values.billing_period.start_date + ' to ' + values.billing_period.end_date;

        doc.setFontSize(11);
        doc.setTextColor(0);
        doc.setFont('helvetica', 'normal');
        let usagePeriodValueY = 90;
        doc.text(usagePeriodValue, pageWidth - 115, 90, { align: 'right' });

        //Payment status
        const status = 'Status: ';
        doc.setFontSize(11);
        doc.setTextColor(0);
        doc.setFont('helvetica', 'bold');
        doc.text(status, 140, 90);

        // Check the state value
        if (values.state === 0) {
            doc.setTextColor(0, 128, 0);
            doc.setFont('helvetica', 'normal');
            doc.text("Paid", 155, 90);

        } else if (values.state === 1) {
            doc.setTextColor(255, 165, 0);
            doc.setFont('helvetica', 'normal');
            doc.text("Pending", 155, 90);

        } else if (values.state === 2) {
            doc.setTextColor(255, 165, 0);
            doc.setFont('helvetica', 'normal');
            doc.text("Pending", 155, 90);
        }


        // Add divider line
        const lineY3 = 97; // Y-coordinate of the line
        const lineLength3 = doc.internal.pageSize.width - 32;

        doc.setLineWidth(0.5);
        doc.setDrawColor('#CCCCCC');
        doc.line(20, lineY3, 20 + lineLength3, lineY3);

        // Generate the usage table
        const tableData = [
            ['Service Type', 'Usage', 'Calculation', 'Sub Total($)'],
        ];
        const modelTableBodyRow = (values && values.bill_calculation) && values.bill_calculation.map((value, index) => (
            [
                value.usage_type,
                value.usage_type === "Carried Forward" ? '-' : value.usage_count,
                value.usage_type === "Carried Forward" ? '-' : value.usage_fee_per,
                value.total_per_services === 0 ? '0.00' : value.total_per_services.toFixed(2)
            ]
        ));

        doc.autoTable({
            margin: { left: 20 },
            startY: usagePeriodValueY + 15,
            head: tableData,
            body: modelTableBodyRow,
            headStyles: {
                fillColor: '#AED4F4',
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                cellPadding: 3,
            },
            bodyStyles: {
                fillColor: '#FFFFFF',
                textColor: [128, 128, 128],
                cellPadding: 3,
            },
            didDrawCell: function (data) {
                const lineWidth = 0.1;
                doc.setDrawColor(169, 169, 169);
                doc.setLineWidth(lineWidth);
                doc.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + data.cell.width, data.cell.y + data.cell.height);
            },
            didParseCell: function (data) {
                const columnIndex = data.column.index;

                if (columnIndex === 3) {
                    // Align the data in the 4th column (index 3) to the right
                    data.cell.styles.halign = 'right';
                }
            },
        });

        // Total Bill
        const totalBill = 'Total bill amount';
        doc.setFontSize(11);
        doc.setTextColor(0);
        doc.setFont('helvetica', 'bold');
        doc.text(totalBill, 145, 153,);

        const TotalBillValue = values && values.total_bill_amount === 0 ? '0.00' : (values && values.total_bill_amount).toFixed(2);

        doc.setFontSize(11);
        doc.setTextColor(0);
        doc.setFont('helvetica', 'normal');
        doc.text(`$${TotalBillValue}`, pageWidth - 17, 153, { align: 'right' });

        // Add divider line
        const lineY4 = 156;
        const lineLength4 = doc.internal.pageSize.width - 32;

        doc.setLineWidth(0.5);
        doc.setDrawColor('#CCCCCC');
        doc.line(20, lineY4, 20 + lineLength4, lineY4);


        const inquiries = [
            'For inquiries related to our product, you may contact:'
        ];
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        doc.setFont('helvetica', 'normal');
        doc.text(inquiries, 20, 165);

        const supportService = [
            'achirashamal@electrobeam.com',
            'support@hiretrace.io'
        ];
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.setFont('helvetica', 'normal');
        doc.text(supportService.join('\n'), 20, 170);

        const payTo = 'Pay To';
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        doc.setFont('helvetica', 'bold');
        doc.text(payTo, 140, 45);

        // Add billing address
        const companyAddress = [
            'Electrobeam (Private) Limited',
            'https://www.electrobeam.com',
            'No 37/6, Mangala Mawatha, ',
            'Kalutara North.',
            // 'Kalutara Reg No: PV 00218390',
            'achirashamal@electrobeam.com',
            '0342225683',
        ];
        doc.setFontSize(11);
        doc.setTextColor(128, 128, 128);
        doc.setFont('helvetica', 'normal');
        doc.text(companyAddress.join('\n'), 140, 50);

        // Save and download the PDF
        doc.save('invoice.pdf');
        }
        
    };
    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(tableFiltervalues?.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(tableFiltervalues?.length / itemsPerPage);

    useEffect(() => {
        getAllBillingDetails();
        setCompanyPaymentState(JSON.parse(localStorage.getItem('paymentStatus')));
    }, [])


    useEffect(() => {
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [])


    return (
        <div>
            <Helmet>
                <title>Billing | HireTrace</title>
            </Helmet>

            {/* Edit Billing contact Details modal Start */}

            <Modal
                show={isModalOpen}
                onHide={() => setModalOpen(false)}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={styles.modalBodyWrapper}>
                <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={() => setModalOpen(false)}>
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <Row>
                        <Col>
                            <Row className={styles.modalHeaderIconDiv}>
                            
                                    <CustomModalIcon
                                        type="squareOutlinedIcon"
                                        icon={
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M14 9H11.5C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.5C13.3284 12 14 12.6716 14 13.5C14 14.3284 13.3284 15 12.5 15H10M12 8V9M12 15V16M18 12H18.01M6 12H6.01M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2ZM18.5 12C18.5 12.2761 18.2761 12.5 18 12.5C17.7239 12.5 17.5 12.2761 17.5 12C17.5 11.7239 17.7239 11.5 18 11.5C18.2761 11.5 18.5 11.7239 18.5 12ZM6.5 12C6.5 12.2761 6.27614 12.5 6 12.5C5.72386 12.5 5.5 12.2761 5.5 12C5.5 11.7239 5.72386 11.5 6 11.5C6.27614 11.5 6.5 11.7239 6.5 12Z"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        } 
                                    />
                            </Row>
                        </Col>
                    </Row>
                    <div>
                        <p className={styles.modalHeaderTopic}>Edit billing contact details</p>
                        <p className={styles.modalHeaderSubTopic}>These details will be used only in billing purpose</p>
                    </div>

                    <Formik
                        validationSchema={schema}
                        onSubmit={(values) => onSubmit(values)}
                        initialValues={{ mnumber: (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.phone_no, address: (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.street_address, city: (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.city, country: (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.country, province: (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.province, postalCode: (billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.postal_code }}>

                        {({
                            values,
                            errors,
                            setFieldValue,
                            handleChange,
                            handleSubmit,
                            submitCount
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Col className={styles.colWithNoSidePadding}>
                                    <Form.Group controlId="exampleForm.SelectCustom">
                                        <Form.Label
                                            className={styles.defaultLabel}>
                                            Phone Number
                                        </Form.Label>
                                        <PhoneInput
                                            country='us'
                                            value={values.mnumber || ''}
                                            onChange={(value, country, e, formattedValue) => { setFieldValue('mnumber', formattedValue) }}
                                            isValid={(submitCount > 0 && errors.mnumber) ? false : true}
                                            inputClass={(submitCount > 0 && errors.mnumber) ? `${styles.inputboxNumberError}` : `${styles.inputboxNumber}`}
                                        />
                                        {submitCount > 0 &&
                                            <p className={styles.numberErrorMsg}>{errors.mnumber}</p>
                                        }
                                    </Form.Group>
                                </Col>
                                <Col  className={styles.colWithNoSidePadding}>
                                    <CustomTextField
                                        label="Street Address"
                                        classLabel="defaultLabel"
                                        controlId="address"
                                        type="text"
                                        value={values.address}
                                        name="address"
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        maxlength={100}
                                        errorMessage={errors.address}
                                        isInvalid={submitCount > 0 && !!errors.address}
                                    />
                                    <Row>
                                        <Col>
                                            <CustomTextField
                                                label="City"
                                                classLabel="defaultLabel"
                                                controlId="city"
                                                type="text"
                                                value={values.city}
                                                name="city"
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                errorMessage={errors.city}
                                                isInvalid={submitCount > 0 && !!errors.city}
                                            />
                                        </Col>
                                        <Col>
                                            <CustomTextField
                                                label="Country"
                                                classLabel="defaultLabel"
                                                controlId="country"
                                                type="text"
                                                value={values.country}
                                                name="country"
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                errorMessage={errors.country}
                                                isInvalid={submitCount > 0 && !!errors.country}
                                            />
                                        </Col>
                                    </Row>


                                    <CustomTextField
                                        label="Province / State"
                                        classLabel="defaultLabel"
                                        controlId="province"
                                        type="text"
                                        value={values.province}
                                        name="province"
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.province}
                                        isInvalid={submitCount > 0 && !!errors.province}
                                    />
                                    <CustomTextField
                                        label="Postal Code"
                                        classLabel="defaultLabel"
                                        controlId="postalCode"
                                        type="text"
                                        value={values.postalCode}
                                        name="postalCode"
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.postalCode}
                                        isInvalid={submitCount > 0 && !!errors.postalCode}
                                    />
                                </Col>
                                <Col  className={styles.colWithNoSidePadding}>
                                    <div className={styles.navigateBtnCol}>
                                        <CustomButton
                                            id="billing_save_contact_details_btn"
                                            buttonType="submit"
                                            label="Save"
                                            type="primaryBtn"
                                            disabled={((props.permissions.actions.billing_actions === false && props.role === 1) || (isLoading === true)) ? true : false}
                                            backicon={isLoading === true && <i className="fas fa-circle-notch fa-spin"></i>}
                                        />
                                    </div>
                                </Col>

                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>

            {/* Edit Billing contact Details modal End */}

            {/* billing details modal start*/}
            <Modal
                show={isDetailsModalOpen}
                onHide={() => setDetailsModalOpen(false)}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
            >
                <Modal.Body className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={() => setDetailsModalOpen(false)}>
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <Row>
                        <Col>
                            <Row className={styles.modalHeaderIconDiv}>
                            
                                    <CustomModalIcon
                                        type="squareOutlinedIcon"
                                        icon={
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 24" fill="none">
                                                <path d="M21.7104 15.89C21.0742 17.3945 20.0792 18.7202 18.8123 19.7513C17.5454 20.7824 16.0452 21.4874 14.4428 21.8048C12.8405 22.1221 11.1848 22.0421 9.62055 21.5718C8.05627 21.1014 6.63103 20.2551 5.46942 19.1066C4.30782 17.9582 3.44522 16.5427 2.95704 14.9839C2.46886 13.4251 2.36996 11.7705 2.669 10.1646C2.96804 8.55877 3.6559 7.05062 4.67245 5.77202C5.689 4.49342 7.00329 3.48331 8.5004 2.82999M21.7392 8.17316C22.1395 9.13962 22.3851 10.1614 22.4684 11.2008C22.489 11.4576 22.4993 11.586 22.4483 11.7017C22.4057 11.7983 22.3213 11.8897 22.2284 11.9399C22.1172 12 21.9783 12 21.7004 12H13.3004C13.0204 12 12.8804 12 12.7734 11.9455C12.6793 11.8976 12.6028 11.8211 12.5549 11.727C12.5004 11.62 12.5004 11.48 12.5004 11.2V2.79999C12.5004 2.52213 12.5004 2.38319 12.5605 2.27198C12.6107 2.17907 12.7021 2.09468 12.7987 2.05209C12.9144 2.00109 13.0428 2.01139 13.2996 2.03198C14.339 2.11531 15.3608 2.36088 16.3272 2.7612C17.5405 3.26375 18.6429 4.00034 19.5715 4.92893C20.5001 5.85751 21.2367 6.9599 21.7392 8.17316Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        } 
                                    />
                            </Row>
                        </Col>
                    </Row>
                    <div>
                        <p className={styles.modalHeaderTopic}>Current Bill Breakdown</p>
                        <p className={styles.modalHeaderSubTopic}>Fees calculated based on the actual usage </p>
                    </div>
                    <Row>
                        <div className={styles.modalTableMainDiv}>
                            <Col sm={12} md={3} className='m-0 p-0'>
                                <div className={styles.chartBox}>
                                    <Chart
                                        height={"150px"}
                                        width={"150px"}
                                        chartType="PieChart"
                                        options={(currentCandidateAmount === 0 && currentInterviewAmount === 0) ? stepPieDataNoneOptions : stepPieOptions}
                                        data={(currentCandidateAmount === 0 && currentInterviewAmount === 0) ?
                                            [
                                                ['Candidate Amount', 'Interview Amount'],
                                                ['', 1],
                                            ]
                                            :
                                            [
                                                ['Candidate Amount', 'Interview Amount'],
                                                ['Candidate Amount', currentCandidateAmount],
                                                ['Interview Amount', currentInterviewAmount],
                                            ]
                                        }
                                    />
                                </div>
                                <div>
                                    <div className={styles.chartOverviewDetails}>
                                        <svg className={styles.chartOverviewDetailsIcon} xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                            <circle cx="4" cy="4" r="4" fill="#2DA6C0" />
                                        </svg>
                                        <p className={styles.chartOverviewDetailsText}>Candidates</p>
                                    </div>
                                    <div className={styles.chartSecondaryOverviewDetails}>
                                        <svg className={styles.chartOverviewDetailsIcon} xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                            <circle cx="4" cy="4" r="4" fill="#12B76A" />
                                        </svg>
                                        <p className={styles.chartOverviewDetailsText}>Interview Minutes</p>
                                    </div>

                                </div>
                            </Col>
                            <Col className={styles.secondOverviewDiv}>
                                <Table striped bordered hover responsive className={styles.serviceCard}>
                                    <thead>
                                        <tr>
                                            <th>SERVICE TYPE</th>
                                            <th>USAGE</th>
                                            <th>CALCULATION</th>
                                            <th>SUB TOTAL ($)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableBodyRow}
                                        {tableSecondBodyRow}
                                    </tbody>
                                </Table>
                            </Col>
                        </div>

                    </Row>
                </Modal.Body>
            </Modal>


            {isDataLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>
                    <div >
                        <div className={styles.billingBodyContainer}>
                            {billingDetails && billingDetails.billing_contact_details && billingDetails.billing_contact_details.is_billing_contact_details_set === false &&
                                <CustomAlertBox
                                    alertBodyText="Billing contact details not submitted !"
                                    alertType="warningAlert"
                                />
                            }
                            {billingDetails && billingDetails.billing_contact_details && companyPaymentState === true &&
                                <CustomAlertBox
                                    alertBodyText="Account blocked due to bill overdue !"
                                    alertType="warningAlert"
                                />
                            }
                            <Row className="mb-5">
                                <Col xs={12} md={4} >
                                    <div className={styles.currentBillWrapper}>
                                        <Col  className={styles.currentBillDiv}>
                                            <Row className={styles.currentBillTitleDiv}>
                                                <Col xs={12}  className={styles.colWithNoSidePadding}>
                                                    <p className={styles.currentBillTitle}>Current Bill</p>
                                                    <p className={styles.currentBillSubTitle}>Pay only after invoice generated</p>

                                                    {billingDetails && 
                                                        <div className={styles.currentBillStatusDiv}>
                                                            <CustomStatusLabel type={billingDetails.is_free_trail === true  ? 'successStatus' : 'secondaryStatus' } label={billingDetails.is_free_trail === true  ? `Free Trial (${billingDetails.days_to_expire_free_trial} days left)` :  'Pay as you go'}></CustomStatusLabel>
                                                        </div>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className={styles.currentBillCalculationDiv}>
                                                <Col xs={12}  className={styles.colWithNoSidePadding}>
                                                    <p className={styles.currentBillTotalValueWapper}>
                                                        <span className={styles.currentBillTotalValue}>USD {billingDetails && billingDetails.total_bill_amount === 0 ? '0.00' : (billingDetails.total_bill_amount).toFixed(2)}</span>
                                                        <a onClick={() => { setDetailsModalOpen((billingDetails && billingDetails.total_bill_amount > 0) ? true :false) }}>
                                                            <span className={(billingDetails && billingDetails.total_bill_amount > 0) ? styles.currentBillTotalValueBreakDownLink : styles.currentBillTotalValueBreakDownLinkDisabled}> Breakdown 
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M5.83331 14.1667L14.1666 5.83334M14.1666 5.83334H5.83331M14.1666 5.83334V14.1667" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                                </svg>
                                                            </span>
                                                        </a>
                                                    </p>
                                                    <p className={styles.currentBillPeriodText}>From <span className={styles.currentBillPeriodHighligntedText}>{moment(billingDetails.bill_calculation?.time_period?.start_date).format('MMM D YYYY')}</span>  to <span className={styles.currentBillPeriodHighligntedText}>{moment(billingDetails.bill_calculation?.time_period?.end_date).format('MMM D YYYY')}</span> </p>
                                                </Col>
                                            </Row>
                                        </Col>

                                    </div>
                                    <div>

                                    </div>
                                    

                                </Col>
                                <Col xs={12} md={8}>
                                    <div className={styles.billingContactDetailsWrapper}> 
                                        <Col  className={styles.billingContactDetailsDiv}>
                                            <Row className={styles.billingContactDetailsTitleDiv}>
                                                <Col xs={10} className={styles.colWithNoSidePadding}>
                                                    <p className={styles.billingContactDetailsTitle}>Billing Contact Details</p>
                                                    <p className={styles.billingContactDetailsSubTitle}>Billing contact details use for only bill generation</p>
                                                    
                                                </Col>
                                                <Col xs={2} className={styles.colWithNoSidePadding}>
                                                    <div className={styles.billingContactDetailsEditBtnDiv}>
                                                        <CustomButton
                                                            id="billing_edit_contact_details_btn"
                                                            buttonType="submit"
                                                            label="Edit"
                                                            type="defaultSmallBtn"
                                                            handleClick={() => setModalOpen(true)}
                                                            frontIcon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 19 19" fill="none">
                                                                    <path d="M8.5 2.76777H5C3.59987 2.76777 2.8998 2.76777 2.36502 3.04025C1.89462 3.27994 1.51217 3.66239 1.27248 4.13279C1 4.66757 1 5.36764 1 6.76777V13.7678C1 15.1679 1 15.868 1.27248 16.4027C1.51217 16.8731 1.89462 17.2556 2.36502 17.4953C2.8998 17.7678 3.59987 17.7678 5 17.7678H12C13.4001 17.7678 14.1002 17.7678 14.635 17.4953C15.1054 17.2556 15.4878 16.8731 15.7275 16.4027C16 15.868 16 15.1679 16 13.7678V10.2678M5.99998 12.7678H7.39543C7.80308 12.7678 8.00691 12.7678 8.19872 12.7217C8.36878 12.6809 8.53135 12.6135 8.68047 12.5222C8.84867 12.4191 8.9928 12.275 9.28105 11.9867L17.25 4.01777C17.9404 3.32741 17.9404 2.20812 17.25 1.51777C16.5596 0.827412 15.4404 0.827411 14.75 1.51777L6.78103 9.48672C6.49277 9.77497 6.34865 9.9191 6.24558 10.0873C6.1542 10.2364 6.08686 10.399 6.04603 10.569C5.99998 10.7609 5.99998 10.9647 5.99998 11.3723V12.7678Z"  stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                                </svg>
                                                            }
                                                        />
                                                    </div>
                                                    
                                                </Col>
                                            </Row>
                                            <Row  className={styles.billingContactDetailsValuesDiv}>
                                                <Col sm={5} className={styles.colWithNoSidePadding}>
                                                    <p className={styles.billingContactDetailsItemWithRightPadding}><span className={styles.billingContactDetailsLabel}>Phone : </span><span className={styles.billingContactDetailsValue}>{(billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? 'Not available' : billingDetails.billing_contact_details?.phone_no}</span> </p>
                                                    <p className={styles.billingContactDetailsItemWithRightPadding}><span className={styles.billingContactDetailsLabel}>Country : </span><span className={styles.billingContactDetailsValue}>{(billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? 'Not available' : billingDetails.billing_contact_details?.country}</span></p>
                                                    <p className={styles.billingContactDetailsItemWithRightPadding}><span className={styles.billingContactDetailsLabel}>State/ Provice : </span><span className={styles.billingContactDetailsValue}>{(billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? 'Not available' : billingDetails.billing_contact_details?.province}</span></p>
                                                </Col> 
                                                <Col sm={7} className={styles.colWithNoSidePadding}>
                                                    <p className={styles.billingContactDetailsItem}><span className={styles.billingContactDetailsLabel}>City : </span><span className={styles.billingContactDetailsValue}>{(billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? 'Not available' : billingDetails.billing_contact_details?.city}</span></p>
                                                    <p className={styles.billingContactDetailsItem}><span className={styles.billingContactDetailsLabel}>Postal Code : </span><span className={styles.billingContactDetailsValue}>{(billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? 'Not available' : billingDetails.billing_contact_details?.postal_code}</span></p>
                                                    <p className={styles.billingContactDetailsItem}><span className={styles.billingContactDetailsLabel}>Address : </span><span className={styles.billingContactDetailsValue}>{(billingDetails && billingDetails.billing_contact_details) && billingDetails.billing_contact_details.is_billing_contact_details_set === false ? 'Not available' : billingDetails.billing_contact_details?.street_address}</span></p>
                                                </Col>
                                            </Row>
                                        </Col>

                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mb-4">
                                    <div className="mb-4 p-0">
                                        <p className={styles.invoiceListTitle}>Bill Invoices</p>
                                    </div>

                                    <div className={styles.tableContainer}>
                                        <div className={styles.tableFirstRowMainHeaderDiv}>
                                            <Col sm={4} className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                                <p>Invoice Period</p>
                                            </Col>

                                            <Col sm={2} className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                                <p>Generated At</p>
                                            </Col>
                                            <Col sm={2} className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                                <p>Status</p>
                                            </Col>
                                            <Col sm={2} className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                                <p>Amount</p>
                                            </Col>
                                            <Col sm={1}>
                                                <Row className={styles.tableDetailsMainHeaderRowCentered}>
                                                    <p>Pay</p>
                                                </Row>
                                            </Col>
                                            <Col sm={1}>
                                                <Row className={styles.tableDetailsMainHeaderRowCentered}>
                                                    <p>Invoice</p>
                                                </Row>
                                            </Col>
                                        </div>
                                    
                                    {tableFiltervalues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((bill, i) => {
                                        return (
                                            <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                                <Col sm={4}>
                                                    <Row className={styles.tableFirstColumnData}>
                                                        <Col sm={2}>
                                                            <div className={styles.tableMainIconDiv}>
                                                                <CustomPreIcon
                                                                    type={bill.state === 0 ? 'successIcon' : bill.state === 1 ? 'warningIcon' : bill.state === 2 ? 'dangerIcon' : ''}
                                                                    icon={
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                            <path d="M11.6667 1.89121V5.33333C11.6667 5.80004 11.6667 6.0334 11.7575 6.21166C11.8374 6.36846 11.9649 6.49594 12.1217 6.57584C12.2999 6.66666 12.5333 6.66666 13 6.66666H16.4421M16.6667 8.32352V14.3333C16.6667 15.7335 16.6667 16.4335 16.3942 16.9683C16.1545 17.4387 15.7721 17.8212 15.3017 18.0608C14.7669 18.3333 14.0668 18.3333 12.6667 18.3333H7.33334C5.93321 18.3333 5.23315 18.3333 4.69837 18.0608C4.22796 17.8212 3.84551 17.4387 3.60583 16.9683C3.33334 16.4335 3.33334 15.7335 3.33334 14.3333V5.66666C3.33334 4.26653 3.33334 3.56647 3.60583 3.03169C3.84551 2.56128 4.22796 2.17883 4.69837 1.93915C5.23315 1.66666 5.93321 1.66666 7.33334 1.66666H10.0098C10.6213 1.66666 10.927 1.66666 11.2148 1.73574C11.4698 1.79698 11.7137 1.89799 11.9374 2.03506C12.1897 2.18967 12.4059 2.40586 12.8382 2.83824L15.4951 5.49509C15.9275 5.92747 16.1437 6.14366 16.2983 6.39595C16.4353 6.61963 16.5364 6.86349 16.5976 7.11858C16.6667 7.4063 16.6667 7.71204 16.6667 8.32352Z"  stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                    }
                                                                />
                                                                
                                                            </div>

                                                        </Col>
                                                        <Col sm={10}>
                                                            <Row className={styles.tableDataLeftAligned}> 
                                                                <p className={styles.tableDataSingleRow}>{(bill && bill.billing_period) && moment(bill.billing_period?.start_date).format('MMM D YYYY')} to {(bill && bill.billing_period) && moment(bill.billing_period?.end_date).format('MMM D YYYY')}</p>
                                                            </Row>
                                                        </Col>

                                                    </Row>

                                                </Col>
                                                <Col sm={2} >
                                                    <Row className={styles.tableDataLeftAlignedPlainText}>
                                                        <p className={styles.tableDataSingleRow}>{moment(bill.date_of_bill_generation).format('LL')}</p>
                                                    </Row>
                                                </Col>
                                                <Col sm={2} className={styles.tableDataStatus}>
                                                    <CustomStatusLabel type={bill.state === 0 ? 'successStatus' : bill.state === 1 ? 'warningStatus' : 'dangerStatus'} label={bill.state === 0 ? 'Paid' : bill.state === 1 ? 'Pending Payment' : 'Overdue'}></CustomStatusLabel>
                                                </Col>
                                                <Col sm={2}>
                                                    <Row className={styles.tableDataLeftAlignedPlainText}>
                                                        <p className={styles.tableDataSingleRow}>USD ${(bill.total_bill_amount).toFixed(2)}</p>
                                                    </Row>
                                                </Col>
                                                <Col sm={1}>

                                                <Row className={styles.tableDataActions}>
                                                        {!(bill.state === 0) && <div className={styles.tableDatActionsLeftBtns}>
                                                        <CustomButton
                                                                buttonType="button"
                                                                label="Pay"
                                                                type="successSmallBtn"
                                                                handleClick={() => paynow(bill._id)}
                                                                disabled ={isPaymentLoading === true || bill.payment_button_enabled === false ? true : false}
                                                            />
                                                        </div>
                                                        }
                                                        
                                                    </Row>
                                                </Col>
                                                <Col sm={1}>
                                                    <Row className={styles.tableDataActions}>
                                                    <div>
                                                            <CustomIconButton
                                                                    type="secondaryBtn"
                                                                    // showToolTip={true}
                                                                    // toolTip={'Delete user'}
                                                                    // toolTipId={'manage_users_delete_user_icon_btn_tool_tip'}
                                                                    id={'manage_users_delete_user_icon_btn'}
                                                                    icon={
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none">
                                                                            <path d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                        </svg>
                                                                    }
                                                                    handleClick={() => downloadAsPDF(bill)} 
                                                                />
                                                        </div>
                                                    </Row>
                                                </Col>

                                            </div>
                                        )
                                    })}
                                    
                                    </div>

                                    {tableFiltervalues?.length > 9 &&
                                        <div className={styles.bottomTableDiv}>
                                            <div className={styles.bottomTableControlsWrapper}>
                                                <div className={styles.bottomTableControlsNextBtn}>
                                                    <CustomButton
                                                        id="billing_invoices_go_to_previous_page_btn"
                                                        label="Previous"
                                                        type="defaultSmallBtn"
                                                        handleClick={handlePreviousClick}
                                                        disabled={currentPage === 1}
                                                    />
                                                </div>
                                                <div>
                                                    <CustomButton
                                                        id="billing_invoices_go_to_next_page_btn"
                                                        label="Next"
                                                        type="defaultSmallBtn"
                                                        handleClick={handleNextClick}
                                                        disabled={currentPage === Math.ceil(tableFiltervalues.length / itemsPerPage)}
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <span className={styles.paginationInfo}>
                                                    Page {currentPage} of {totalPages}
                                                </span>
                                            </div>

                                        </div>
                                    }

                                    {(!tableFiltervalues || tableFiltervalues.length <=0 )&& 
                                        <div className={styles.tableNoRecordsMsgDiv}>
                                            <p className={styles.tableNoRecordsMsgDiv}>No generated bills yet</p>
                                        </div>
                                    }
                                </Col>
                            </Row>
                        </div>
                    </div>

                </div >)
            }
        </div >
    )
}

export default Billing;
